import { defineComponent } from '@digitalbranch/app'

import template from './page-header.html'
import css from './page-header.css'

export const pageHeader = defineComponent({
  name: 'page-header',
  css,
  template,
})
